// extracted by mini-css-extract-plugin
module.exports = {"regionDialog":"RegionDialog_regionDialog__2CbcU","icon":"RegionDialog_icon__w45Xp"};